import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { LoginPage } from '@/features/auth/components/LoginPage'
import { redirectAuthenticated } from '@/features/auth/route-access'

const searchSchema = z.object({
  /**
   * Still accepted so `/login?redirect=…` links from older builds keep validating.
   * The destination is always the dashboard, not this untrusted param.
   */
  redirect: z.string().optional(),
  registered: z.boolean().optional(),
  passwordReset: z.boolean().optional(),
})

export const Route = createFileRoute('/login')({
  validateSearch: searchSchema,
  beforeLoad: redirectAuthenticated,
  component: LoginPage,
})
